import { Box, MenuItemProps, Tooltip } from '@televet/kibble-ui';
import { Text } from '@televet/kibble-ui/build/components/Text';
import React from 'react';
import { ChannelViewClinicPetParentFragment } from 'shared/types/graphql';
import { selectPrimaryPhoneNumberBestGuess } from 'shared/utils';

/**
 * Transform an array of clinic pet parents into an array of options for use in a dropdown
 * @param parents
 */
export const getPetParentsForContact = (
  parents: ChannelViewClinicPetParentFragment[],
): {
  petParentOptions: MenuItemProps[];
  petParentOptionsMap: Map<string, ChannelViewClinicPetParentFragment>;
} => {
  const petParentOptions: MenuItemProps[] = [];
  const petParentOptionsMap = new Map<string, ChannelViewClinicPetParentFragment>();

  for (const parent of parents) {
    const label = [parent.firstName, parent.lastName].join(' ').trim();
    const isDisabled = !selectPrimaryPhoneNumberBestGuess(parent?.phoneNumbers || []);
    petParentOptions.push({
      label,
      value: parent.id,
      isDisabled,
      children: isDisabled ? (
        <Tooltip label={`${parent.firstName} ${parent.lastName} does not have a saved phone number.`}>
          <Box>
            <Text>{label}</Text>
          </Box>
        </Tooltip>
      ) : undefined,
    });
    petParentOptionsMap.set(parent.id, parent);
  }

  return { petParentOptions, petParentOptionsMap };
};

export const formatNames = (names: string[], maxLength?: number): string => {
  const base = names.slice(0, 2).join(', ');
  const extraCount = names.length - 2;
  const suffix = extraCount > 0 ? `, +${extraCount} More` : '';
  const fullText = base + suffix;

  if (!maxLength || fullText.length <= maxLength) {
    return fullText;
  }

  const allowedBaseLength = maxLength - suffix.length;
  if (allowedBaseLength <= 0) {
    return suffix;
  }

  let truncatedBase = base;
  if (base.length > allowedBaseLength) {
    let truncated = base.substring(0, allowedBaseLength);
    const lastSpace = truncated.lastIndexOf(' ');
    if (lastSpace > 0) {
      truncated = truncated.substring(0, lastSpace);
    }
    truncatedBase = truncated + '…';
  }

  return truncatedBase + suffix;
};
